import { render, staticRenderFns } from "./PaginaCondicionesLegales.vue?vue&type=template&id=72421656&"
import script from "./PaginaCondicionesLegales.vue?vue&type=script&lang=js&"
export * from "./PaginaCondicionesLegales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports